<div class="relative my-8 flex flex-auto flex-col items-center gap-8">
  @if (file(); as file) {
    <div class="w-full max-w-3xl shadow">
      <div class="surface-default flex w-full max-w-3xl flex-col gap-4 rounded-xl border border-gray-5 p-4">
        <div class="flex flex-col gap-4">
          <div class="flex w-full sm:items-center">
            <div class="flex w-full items-center gap-4">
              @if (file.uploadedBy; as user) {
                <aura-avatar
                  [label]="user.identity.firstName"
                  [srcImage]="$safeNavigationMigration(user.identity.avatar?.url)"
                  [size]="'l'"
                />
              }

              <div class="flex flex-col">
                <div class="text-xl font-semibold">
                  @if (file.uploadedBy; as user) {
                    <button
                      mat-button
                      class="link text-xl font-semibold"
                      [matTooltip]="'Utilisateur'"
                      [routerLink]="['/users', user._id]"
                    >
                      {{ user.identity.firstName | titlecase }}
                      {{ user.identity.lastName | titlecase }}
                    </button>
                  }
                </div>
                <div>{{ file.purpose | filePurposeDisplay }}</div>
              </div>
            </div>
            <div class="flex w-full justify-end">
              <div [matTooltip]="'Modifié: ' + (file.updatedAt | luxonDate: 'dd/LL/yyyy HH:mm')">
                {{ file.createdAt | luxonDate: 'dd/LL/yyyy HH:mm' }}
              </div>
            </div>
          </div>
        </div>
        <mat-divider></mat-divider>

        @if (file.state.status !== 'active') {
          <aura-details-panel [title]="'Statut du fichier'" [sections]="fileDetails()" />
        }

        <aura-details-panel [title]="'Fichier source'" [sections]="fileSources()">
          <img [src]="file.url" alt="image-detail" />
        </aura-details-panel>

        @if (fileThumbnails()) {
          @for (thumbnail of fileThumbnails(); track $index) {
            <aura-details-panel [title]="'Version ' + thumbnail.key" [sections]="thumbnail.columns">
              <img [src]="thumbnail.url" alt="thumbail-detail" />
            </aura-details-panel>
          }
        }
      </div>
    </div>
  }
</div>
